import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Bonjour!',
  ProductCode: 'fer42',
  Description:
    '<p>Here&#39;s all the online content included with your <strong>French Revision Guide</strong>.&nbsp;</p>\n',
  Credits:
    '<p><em>Contributors: Ben Ffrancon Dowds, Sarah Sweeney</em></p>\n' +
    '\n' +
    '<p><em>Proofreaders: Marie-Laure Delvallé, Natalie Pomier, Véronique Robine</em></p>\n' +
    '\n' +
    '<p><em>Questions throughout are based on Pearson Edexcel type questions.</em></p>\n' +
    '\n' +
    '<p><em>Audio produced by Voice Talent Online.</em></p>\n' +
    '\n' +
    '<p><em>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2024. All rights reserved.</em></p>\n',
};
